import Router from 'vue-router'

export default new Router({
    mode: 'history',
    routes: [
        {
            name: 'index',
            path: '/'
        },
        {
            name: 'slides',
            path: '/slides/:slideId'
        },
        {
            name: 'cases',
            path: '/cases/:caseId'
        },
        {
            name: 'about',
            path: '/about'
        },
        {
            name: 'poll',
            path: '/poll'
        }
    ]
})